import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { AllListsPage } from '~/features/lists/all-lists-page';

/** `?create=true` opens the New list sheet over the table. */
const search = z.object({ create: z.boolean().optional() });

function ListsRoute(): ReactElement {
  const { create } = Route.useSearch();
  return <AllListsPage create={create === true} />;
}

export const Route = createFileRoute('/_app/lists/')({
  validateSearch: search,
  component: ListsRoute,
});
